import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from '../../redux/globals/globals.selectors';
import './PlayerStats.styles.scss';

const PlayerStats = ({ data }) => {
	const user = useSelector(selectUser);

	return (
		<div className="player-stats">
			<img className="image" src="/assets/ore_icon.png" />
			<div className="data">
				<div className="title">$ORE</div>
				<div className="ore-collected">{data?.oreBallance}</div>
			</div>

		<div className="user">
			<div className="welcome">Welcome</div>
			{user?.name && <div className="name">{`${user?.name.substring(0, 15)}`}</div>}
			{!user?.name && (
				<div className="name">Guest Player</div>
			)}
		</div>

			<div className="onlineStats">
				<span className="players">{data.playercount}</span> Pilots online
			</div>
		</div>
	);
};

export default PlayerStats;
